import React, { useState, createContext } from 'react';
import { StompSessionProvider, useSubscription } from 'react-stomp-hooks';
import { pathWebSocketConfigParams } from '@/helpers/constants';
import useAuth from '@/hooks/useAuth';
import { socketHubEndpoint } from '@/services/serviceConstants';

type SocketContextType = {
  lastMessage: {
    msg: any;
    topic: string;
  };
};

const SocketSessionProvided = ({ children }) => {
  const authService = useAuth();
  const retryInterval = 10000;
  const token = authService.getUserToken();

  return (
    <StompSessionProvider
      enabled={!!token}
      url={socketHubEndpoint}
      brokerURL={socketHubEndpoint}
      connectHeaders={{
        Authorization: `Bearer ${token}`,
      }}
      reconnectDelay={retryInterval}
      onConnect={() => console.log('Connected to WebSocket')}
      onStompError={(error) => { console.error('Stomp error:', error, 'retry in', retryInterval / 1000, 'seconds'); }}
    >
      <SocketContextProvider>
        {children}
      </SocketContextProvider>
    </StompSessionProvider>
  );
};

const SocketContext = createContext<SocketContextType>({ lastMessage: { msg: '', topic: '' } });

const SocketContextProvider = ({ children }) => {
  const [lastMessage, setLastMessage] = useState({ msg: '', topic: '' });

  useSubscription(
    pathWebSocketConfigParams,
    (message) => {
      setLastMessage({ msg: JSON.parse(message?.body), topic: message?.headers?.destination });
    },
  );

  return (
    <SocketContext.Provider value={{ lastMessage }}>
      {children}
    </SocketContext.Provider>
  );
};

export {
  SocketContext,
  SocketSessionProvided,
};
